export default "__VITE_ASSET__D1RXi7Es__"